import gql from 'graphql-tag';

export const POLICY_QUERY = gql`
  query policy(
    $address1_Line1: String,
    $address1_Line2: String,
    $address1_City: String,
    $address1_PostalCode: String,
    $pi: Int
  ) {
    policy(
      address1_Line1: $address1_Line1,
      address1_Line2: $address1_Line2,
      address1_City: $address1_City,
      address1_PostalCode: $address1_PostalCode,
      pi: $pi
    ) {
      id
      address1_Line1
      address1_Line2
      address1_City
      address1_County
      address1_StateOrProvince
      address1_PostalCode
      address2_Line1
      address2_Line2
      address2_City
      address2_StateOrProvince
      address2_PostalCode
      allowRegistration
    }
  }
`
